import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import KotGenerateSlice from "../features/kotGenerate"

// Create and configure the Redux store
export const store = configureStore({
  reducer: {
    // `loginVerify` key will manage state from the loginVerifySlice
    loginVerify: authReducer,

    // `KotGenerated` key will manage state from the KotGenerateSlice
    KotGenerated: KotGenerateSlice
  },
});
